import clsx from 'clsx';
import type { ComponentPropsWithoutRef } from 'react';

/**
 * Display a list of templates in a grid layout.
 */
export function TemplatesList(props: ComponentPropsWithoutRef<'div'>) {
    return (
        <div
            {...props}
            className={clsx(
                'grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3',
                props.className
            )}
        />
    );
}
